export default "__VITE_ASSET__CivjEF7v__"